/*
 Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.

 Licensed under the Amazon Software License (the "License"). You may not use this file
 except in compliance with the License. A copy of the License is located at

 http://aws.amazon.com/asl/

 or in the "license" file accompanying this file. This file is distributed on an "AS IS"
 BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
 License for the specific language governing permissions and limitations under the License.
 */

/* eslint no-console: ["error", { allow: ["warn", "error"] }] */

if (window.__SOPHIE_INITIATE_LOADER_ATTACHED__) {
} else {
  window.__SOPHIE_INITIATE_LOADER_ATTACHED__ = true;

function debugError(message, error = null) {
  if (error) {
    console.error(message, error);
  } else {
    console.error(message);
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  if (typeof window.LexWebUi === 'undefined') {
    // This is expected when using the loader in iframe mode (parent page)
    // where the Vue app (LexWebUi) is not loaded directly.
    return;
  }

  if (typeof window.LexWebUi.Loader === 'undefined') {
    debugError('LexWebUi.Loader not found after library loaded');
    return;
  }

  // Get the container element
  const containerEl = document.getElementById('lex-web-ui-container');
  if (!containerEl) {
    debugError('Container element #lex-web-ui-container not found in DOM');
    return;
  }
  try {
    // Load configuration from JSON file
    let loadedConfig = {};
    let configSource = 'default';
    
    try {
      const fileUrl = './lex-web-ui-loader-config.json';
      const response = await fetch(fileUrl);
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      loadedConfig = await response.json();
      configSource = 'file';
    } catch (fetchError) {
      debugError(`Could not load config file: ${fetchError.message}`, fetchError);
    }
    
    // Default/fallback configuration (UAT-01)
    const defaultConfig = {
      cognito: {
        poolId: "us-east-1:c4d6cc6d-c144-41a8-9508-459afe841a9e"
      },
      lex: {
        v2BotId: "RS5JBLTLBR",
        v2BotAliasId: "NVEZYCOBLX",
        v2BotLocaleId: "en_US",
        initialText: "Hi. I'm Sophie, a DPHHS virtual assistant. How may I assist you?",
        initialSpeechInstruction: "Hi. I'm Sophie, a DPHHS virtual assistant. How may I assist you?",
        reInitSessionAttributesOnRestart: true
      },
      polly: {
        voiceId: "Matthew",
        autoPlayResponse: false
      },
      recorder: {
        enable: false,
        initialSilencePrompt: {
          url: "/audio/initial_speech_en_US.mp3",
          text: "Hi. I'm Sophie, a DPHHS virtual assistant. How may I assist you?"
        },
        silencePrompt: {
          url: "/audio/initial_speech_en_US.mp3",
          text: "Hi. I'm Sophie, a DPHHS virtual assistant. How may I assist you?"
        }
      },
      ui: {
        enableLogin: false,
        forceLogin: false,
        helpIntent: "Help",
        shouldDisplayResponseCardTitle: false,
        textInputPlaceholder: "Please type your question here."
      }
    };
    
    // Deep merge loaded config with defaults (loaded config takes precedence)
    const config = mergeDeep(defaultConfig, loadedConfig);
    // Create the loader with the config
    const lexWebUi = new window.LexWebUi.Loader(config);
    // Mount the app to the container
    lexWebUi.app.mount('#lex-web-ui-container');
  } catch (error) {
    debugError('✗ Error initializing chatbot', error);
    debugError('Error message:', error.message);
    debugError('Stack trace:', error.stack);
  }
});
}

/**
 * Deep merge two objects
 * @param {Object} target - Target object
 * @param {Object} source - Source object to merge into target
 * @returns {Object} Merged object
 */
function mergeDeep(target, source) {
  const output = Object.assign({}, target);
  
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] });
        } else {
          output[key] = mergeDeep(target[key], source[key]);
        }
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }
  
  return output;
}

/**
 * Check if value is an object
 * @param {*} item - Value to check
 * @returns {boolean}
 */
function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item);
}
